import React, { useState } from "react";
import styles from './style.module.css'
import { StoreBot } from "../../assets/svgs";
import { AIAssistantModal } from "../ArtificialAssistance";


export const StoreAIBot: React.FC = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleAssistantClick = () => {
    setIsModalOpen(true);
  };


    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    return (
        <div className={styles.assistanceWrapper}>
            <button
                className={styles.assistanceContainer}
                onClick={handleAssistantClick}>
                <img
                    src={StoreBot}
                    alt="assistance Icon"
                    className={styles.assistanceContainerIcon}
                />
            </button>
        <AIAssistantModal
        isOpen={isModalOpen} 
        onClose={handleCloseModal} 
      />
        </div>
    )
}